module.exports = new __parcel__URL__("books.95459a42.png").toString();